// Format money
function formatMoney(cents) {
  return 'Tk ' + (cents / 100).toFixed(2);
}

// Update header price
function updateHeaderCartTotal() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const el = document.querySelector('[data-cart-subtotal-price]');
      if (el) {
        el.textContent = formatMoney(cart.total_price);
      }
    })
    .catch(err => console.error('Cart fetch error:', err));
}

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  updateHeaderCartTotal();
});

// Intercept AJAX cart changes (add / remove / update)
(function () {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    try {
      const url = args[0];

      if (typeof url === 'string' && url.includes('/cart/')) {
        // wait a little for Shopify to update cart
        setTimeout(() => {
          updateHeaderCartTotal();
        }, 300);
      }
    } catch (e) {
      console.error(e);
    }

    return response;
  };
})();

document.querySelectorAll('.pf-button-1').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault(); // prevent normal form submit

    const form = btn.closest('form');
    if (!form) return;

    const variantId = form.querySelector('input[name="id"]').value;
    const quantity = form.querySelector('input[name="quantity"]')?.value || 1;

    // Disable button and show loader
    btn.disabled = true;
    const originalContent = btn.innerHTML;
    btn.innerHTML = `
      <svg class="spinner" width="16" height="16" viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round"></circle>
      </svg> Adding...
    `;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Added to cart:', data);

      // Show Added state
      btn.innerHTML = 'Added!';
      
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalContent;
      }, 1500);

      // Update cart floating bar
      const floatingBar = document.querySelector('.pro-cart-floating-bar');
      if (floatingBar) floatingBar.style.display = 'flex';

      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const cartCount = document.querySelector('[data-pro-cart-count]');
          const cartSubtotal = document.querySelector('[data-pro-cart-subtotal]');
          if (cartCount) cartCount.textContent = cart.item_count;
          if (cartSubtotal) cartSubtotal.textContent = Shopify.formatMoney(cart.total_price);
        });

    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      btn.disabled = false;
      btn.innerHTML = originalContent;
    });
  });
});